<ion-content class="container">
  <div class="tabs-container">
    <div class="card">
      <ion-row *ngIf="!router.url.includes('Setup')">
        <ion-col size="12" size-md="9" class="pl-15 pr-0 pb-0 p-md-0">
          <div class="borderbottomForTab" *ngIf="!router.url.includes('Setup')">
            <mat-tab-group #tabGroup class="pt-10 pr-10 animated-tabs" [selectedIndex]="selectedTypeTabIndex"
              (selectedTabChange)="tabTypeChanged($event)" *ngIf="
                loggedInUserRole == 'HR Admin' ||
                loggedInUserRole == 'Super Admin' ||
                loggedInUserRole == 'PHI Admin' ||
                findLogdinUserAsaAuthority
              ">
              <mat-tab label="Dashboard">
                <ng-template mat-tab-label>
                  <span class="tab-label">
                    <span class="material-icons mr-10"> speed </span>Dashboard</span>
                </ng-template>
              </mat-tab>
              <mat-tab label="Asset" *ngIf="
                  !(
                    loggedInUserRole == 'HR Admin' ||
                    loggedInUserRole == 'Super Admin' ||
                    loggedInUserRole == 'PHI Admin'
                  )
                ">
                <ng-template mat-tab-label>
                  <span class="tab-label">
                    <span class="material-icons mr-10"> person </span>My
                    Asset</span>
                </ng-template>
              </mat-tab>
              <mat-tab label="Inventory" *ngIf="
                  !(loggedInUserRole == 'HR Admin') &&
                  findLogdinUserAsaAuthority
                ">
                <ng-template mat-tab-label>
                  <span class="tab-label">
                    <span class="material-icons mr-10"> ads_click </span>My Dept
                    Inventory
                  </span>
                </ng-template>
              </mat-tab>
              <mat-tab label="Laptop" *ngIf="
                  loggedInUserRole == 'HR Admin' ||
                  loggedInUserRole == 'Super Admin'
                ">
                <ng-template mat-tab-label>
                  <span class="tab-label">
                    <span class="material-icons mr-10"> ads_click </span>Company
                    Inventory</span>
                </ng-template>
              </mat-tab>

              <!-- Reports Tab -->
              <mat-tab label="Reports">
                <ng-template mat-tab-label>
                  <span class="tab-label">
                    <span class="material-icons mr-10">description</span>Reports
                  </span>
                </ng-template>
              </mat-tab>
            </mat-tab-group>

            <mat-tab-group #tabGroup class="pt-10 pr-10 animated-tabs" [selectedIndex]="selectedTypeTabIndex"
              (selectedTabChange)="tabTypeChanged($event)" *ngIf="
                loggedInUserRole &&
                (loggedInUserRole == 'Employee' ||
                  loggedInUserRole == 'HOD' ||
                  loggedInUserRole == 'Manager') &&
                !findLogdinUserAsaAuthority
              ">
              <mat-tab label="Asset" *ngIf="
                  !(
                    loggedInUserRole == 'HR Admin' ||
                    loggedInUserRole == 'Super Admin' ||
                    loggedInUserRole == 'PHI Admin' ||
                    findLogdinUserAsaAuthority
                  )
                ">
                <ng-template mat-tab-label>
                  <span class="tab-label">
                    <span class="material-icons mr-10"> person </span>My Asset
                  </span>
                </ng-template>
              </mat-tab>

              <mat-tab label="Reports">
                <ng-template mat-tab-label>
                  <span class="tab-label">
                    <span class="material-icons mr-10">description</span>Reports
                  </span>
                </ng-template>
              </mat-tab>
            </mat-tab-group>
          </div>
        </ion-col>

        <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="" class="borderbottomForTab pl-10 pt-10 pr-10" *ngIf="
            !router.url.includes('Setup') &&
            (loggedInUserRole == 'HR Admin' ||
              loggedInUserRole == 'Super Admin' ||
              loggedInUserRole == 'PHI Admin' ||
              loggedInUserRole == 'MD') &&
            !mobileResponsiveService.hideForTabletAndBelow
          ">

          <div class="center-content float-right fade-in-right">
            <div>
              <span class="cp fs-14 fs_12ForMobile link font_regular center-content mr-20 logs-link"
                (click)="onClickLogs('Logs')">
                <img src="././assets/icon/logsIcon.svg"><u>Logs</u>
              </span>
            </div>
            <div>
              <button type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content mr-5 setup-btn"
                [style.background-color]="buttonColorName" (click)="onClickSetup('Setup')">
                <span class="material-icons fs-20 mr-5">settings</span>Setup
              </button>
            </div>
          </div>
        </ion-col>

      </ion-row>
    </div>
    <div class="modal fade" [style.display]="showSetupPopup ? 'block' : 'none'">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="mt-10 d-flex pt-5 pb-10 pr-10 pl-0 headerBreadcrumb" (click)="onClickback()">
            <img src="././assets/icon/backArrow.svg" class="cp" />
            <label class="font_semibold fs-18 fs_16ForMobile ml-10 mt-5 black_color">
              <span class="cp">Asset</span> /
              <span [style.color]="buttonColorName">Setup</span>
            </label>
          </div>
          <div class="modal-body p-20">
            <div class="mt-10">
              <div class="cardBox card" style="background-color: white; padding: 10px">
                <ion-row>
                  <ion-col size="4" class="mt-10">
                    <div class="formLabelRegularfs16 mb-5">
                      Fiscal Year<span class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="inputBoxDisabled">
                      {{ sharedService.transform(loggedInCompanyFiscalyear) }}
                    </div>
                  </ion-col>
                  <ion-col size="4" class="mt-10">
                    <div class="formLabelRegularfs16 mb-5">
                      Year<span class="red-cl">&nbsp;*</span>
                    </div>
                    <mat-form-field class="w-100 mat-height40 mat-input-style">
                      <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"
                        (selectionChange)="getYearSetupForReimbursement()">
                        <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                          {{ sharedService.transformYearToFyFormat(item.year) }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>
                </ion-row>
                <ion-row> </ion-row>
              </div>
            </div>
          </div>
          <div class="modal-body p-10">
            <div class="mt-2">
              <div class="cardBox card">
                <div class="card employeeTab">
                  <div class="card-body">
                    <div>
                      <div class="p-10">

                        <ion-col size="12" size-md="3" class="p-0">
                          <div class="action-btns">

                            <span class="material-icons btn-reset" [class.clicked]="isAuthorityResetClicked"
                              (click)="resetAuthorityGrid(); isAuthorityResetClicked = true"
                              (animationend)="isAuthorityResetClicked = false">
                              refresh
                            </span>

                            <button type="button" class="add_btn fs-14 fs_12ForMobile" (click)="addAuthority(null)">
                              + New Authority
                            </button>

                          </div>
                        </ion-col>

                        <div class="table-container">
                          <ag-grid-angular style="width: 100%" class="ag-theme-quartz" [rowData]="autorityListData"
                            [columnDefs]="columnDefs" [defaultColDef]="defaultColDef"
                            (gridReady)="onGridReady($event, 'authority')" (cellClicked)="onCellClicked($event)"
                            [domLayout]="'autoHeight'" [localeText]="{ noRowsToShow: 'No Data Found' }">
                          </ag-grid-angular>
                        </div>
                        <div class="mt-10" style="font-weight: bold">
                          {{ autorityListData.length }} entries
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-body p-10">
            <div class="mt-10">
              <div class="cardBox card">
                <div class="card employeeTab assetTable">
                  <div class="card-body">
                    <div>
                      <div class="p-10">
                        <ion-col size="12" size-md="3" class="p-0">
                          <div class="action-btns">

                            <span class="material-icons btn-reset" [class.clicked]="isAssetResetClicked"
                              (click)="resetAssetGrid(); isAssetResetClicked = true"
                              (animationend)="isAssetResetClicked = false">
                              refresh
                            </span>


                            <button type="button" class="add_btn fs-14 fs_12ForMobile" (click)="addAsset(null)">
                              + New Asset
                            </button>

                          </div>
                        </ion-col>


                      </div>












                      <div class="table-container">
                        <!-- <table class="custom-table rounded-header">
                            <thead>
                              <tr>
                                <th *ngFor="let item of  assettabaleheader"
                                  class="fs-14 fs_12ForMobile font_bold cl-black">
                                  <div class=" verticle-center justify-content-space-between icon-style">
                                    {{ item?.label }}
                                    <div class="d-flex flex-column ml-10">
                                      <i (click)="onSortAssendingForAsset(item.sortingName)"
                                        class="material-icons materialIconsHeight cp">arrow_drop_up</i>
                                      <i (click)="onSortDesendingForasset(item.sortingName)"
                                        class="material-icons materialIconsHeight cp">arrow_drop_down</i>
                                    </div>
                                  </div>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let row of  AllAssetListingData">
                                <td>{{row.assetName}}</td>
                                <td>{{row.bands}}</td>
                                <td>{{row.authorityDepartment}}</td>
                                <td>{{row.authorityName}}</td>
                                <td>
                                  <img class="mr-5 cp imgdelete" title="Edit" src="././assets/icon/edit.png"
                                    (click)="addAsset(row)" width="25px">
                                  <span class="material-icons fs-20 red cp"
                                    (click)="deleteAasset(row.assetId)">delete</span>
                                </td>
                              </tr>
                            </tbody>
                          </table> -->
                        <ag-grid-angular class="ag-theme-quartz" style="width: 100%" [rowData]="AllAssetListingData"
                          [columnDefs]="columnDefsForAsset" [defaultColDef]="defaultColDef"
                          (gridReady)="onGridReady($event, 'asset')" (cellClicked)="onCellClickedForAsset($event)"
                          [domLayout]="'autoHeight'" [localeText]="{ noRowsToShow: 'No Data Found' }">
                        </ag-grid-angular>
                      </div>
                      <div class="mt-10" style="font-weight: bold">
                        {{ AllAssetListingData.length }} entries
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ion-row> </ion-row>
              <ion-row> </ion-row>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- --------------------------------------------------- Company Inventory ------------------------------- -->
    <div *ngIf="selectedTypeTabName == 'Laptop'" class="p-10">
      <mat-tab-group (selectedTabChange)="subtabTypeChanged($event)">

        <!-- Laptop1 Tab -->
        <mat-tab label="Inventory">

        </mat-tab>

        <mat-tab label="ResignEmp">

        </mat-tab>
        <mat-tab label="TerminateEmp">

        </mat-tab>
      </mat-tab-group>

      <div class="phi-flex-wrap-center-space-between phi-gap-15 mt-10" *ngIf="selectedSubTabName=='Inventory'">

        <mat-form-field class="w-100 mw-sm-250 mb-10 mat-height40 mat-input-style">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="search" placeholder="Search" [(ngModel)]="searchTerm"
            (input)="filterAssets(searchTerm)" />
        </mat-form-field>
        <!-- </ion-col> -->
        <!-- <ion-col> -->
        <div class="mb-10">

          <button type="button" class="add_btn" [style.background-color]="buttonColorName"
            (click)="addNewAssetEmployee(null)">
            + Allocate Assets
          </button>
        </div>
      </div>

      <div class="table-bordered laptopAllocation" *ngIf="selectedSubTabName=='Inventory'">

        <!-- {{assets |json}} -->
        <app-reusable-table [parentHeaders]="parentHeaders" [nestedHeaders]="nestedHeaders" [tableData]="assets"
          [selectedTabName]="selectedTypeTabName" nestedKey="users" (onAssetNameClick)="userAsset($event)"
          expandKey="isExpand" (deleteEmployee)="deleteasset($event)" (onAssetNameClickInside)="employeeAsset($event)">
        </app-reusable-table>
      </div>

      <!-- ----------------------------------------------------------------------------Resign Employee-------------------------------------------------------------- -->
      <div *ngIf="selectedSubTabName == 'ResignEmp' " class="p-10">


        <div class="table-bordered laptopAllocation">

          <!-- {{assets |json}} -->
          <app-resign-employee-asset [year]="selectedYearForCompetency"
            [companyId]="loggedInUserCompanyID"></app-resign-employee-asset>
        </div>
      </div>
      <div *ngIf="selectedSubTabName =='TerminateEmp' " class="p-10">

        <div class="table-bordered laptopAllocation">

          <!-- {{assets |json}} -->
          <app-terminated-employee-asset [year]="selectedYearForCompetency"
            [companyId]="loggedInUserCompanyID"></app-terminated-employee-asset>
        </div>
      </div>
    </div>
    <!----------------------------------------------------------------------- My Dept  InVentory For Specific Authority------------------------------------------------------------------------------------- -->
    <div *ngIf="selectedTypeTabName == 'Inventory'" class="p-20">
      <mat-tab-group (selectedTabChange)="subtabTypeChanged($event)">

        <!-- Laptop1 Tab -->
        <mat-tab label="Inventory">

        </mat-tab>

        <mat-tab label="ResignEmp">

        </mat-tab>
        <mat-tab label="TerminateEmp">

        </mat-tab>
      </mat-tab-group>

      <!-- Row for Add New Asset Button -->
      <div *ngIf="selectedSubTabName=='Inventory'">
        <div class="mb-15 ion-text-end">
          <!-- <button type="button" class="add_btn" style="float: right; margin-bottom: 10px; align-items: center;"
          [style.background-color]="buttonColorName" (click)="allocateAuthority(null)">
          + New Asset
        </button> -->
          <button type="button" class="add_btn mb-10" [style.background-color]="buttonColorName"
            (click)="addNewAssetEmployee(null)">
            + Allocate Assets
          </button>
        </div>

        <!-- Row for Table View -->
        <div class="mt-10 table-bordered laptopAllocation">
          <app-reusable-table [parentHeaders]="parentHeaders" [nestedHeaders]="nestedHeaders"
            [selectedTabName]="selectedTypeTabName" [tableData]="allocatingAsset" [applyAuthorityFilter]="true"
            nestedKey="users" (onAssetNameClick)="allocateAuthority($event)" (deleteEmployee)="deleteasset($event)"
            expandKey="isExpand" (onAssetNameClickInside)="employeeAsset($event)">
          </app-reusable-table>
        </div>
      </div>
      <div *ngIf="selectedSubTabName == 'ResignEmp'" class="p-10">


        <div class="table-bordered laptopAllocation">

          <!-- {{assets |json}} -->
          <app-resign-employee-asset [year]="selectedYearForCompetency"
            [companyId]="loggedInUserCompanyID"></app-resign-employee-asset>
        </div>
      </div>

      <div *ngIf="selectedSubTabName =='TerminateEmp' " class="p-10">

        <div class="table-bordered laptopAllocation">

          <!-- {{assets |json}} -->
          <app-terminated-employee-asset [year]="selectedYearForCompetency"
            [companyId]="loggedInUserCompanyID"></app-terminated-employee-asset>
        </div>
      </div>
    </div>

    <!--    (onAssetNameClickInside)="employeeAsset($event)" -->

    <!-- ----------------------------------------------------------------------------- MY Asset------------------------------------------------------------- -->

    <div *ngIf="
        selectedTypeTabName == 'Asset' ||
        ((loggedInUserRole == 'Employee' || loggedInUserRole == 'Manager') &&
          !findLogdinUserAsaAuthority)
      " style="margin: 20px !important">
      <div class="mt-10 table-bordered laptopAllocation" style="clear: both" *ngIf="selectedTypeTabName !== 'Reports'">
        <app-reusable-table [parentHeaders]="parentHeadersForEmployee" [nestedHeaders]="nestedHeadersForEmployee"
          [tableData]="allocatingEmployee" nestedKey="users" (onAssetNameClickInside)="employeeAsset($event)"
          expandKey="isExpand" [selectedTabName]="selectedTypeTabName">
        </app-reusable-table>
      </div>
    </div>
    <div *ngIf="selectedTypeTabName == 'Reports'" style="margin: 20px !important">
      <app-asset-management-report></app-asset-management-report>
    </div>
    <div *ngIf="
        loggedInUserRole == 'HR Admin' ||
        loggedInUserRole == 'Super Admin' ||
        loggedInUserRole == 'PHI Admin' ||
        loggedInUserRole == 'MD' ||
        (loggedInUserRole == 'Employee' && findLogdinUserAsaAuthority) ||
        (loggedInUserRole == 'Manager' && findLogdinUserAsaAuthority) ||
        (loggedInUserRole == 'HOD' &&
          findLogdinUserAsaAuthority &&
          !router.url.includes('Setup'))
      " style="margin: 20px !important">
      <div *ngIf="
          selectedTypeTabName == 'Dashboard' && !router.url.includes('Setup')
        ">
        <app-asset-dashboard></app-asset-dashboard>
      </div>
    </div>

    <!-- ----------------------------------------------------------------------------Resign Employee-------------------------------------------------------------- -->
    <!-- <div *ngIf="selectedTypeTabName == 'resignation'" class="p-10">


      <div class="table-bordered laptopAllocation">

        <app-resign-employee-asset [year]="selectedYearForCompetency"
          [companyId]="loggedInUserCompanyID"></app-resign-employee-asset>
      </div>
    </div> -->

  </div>
</ion-content>